import {SafeDrivingService} from '../../widgets/templateDrivenWidget/services/safe-driving.service';
import {ReminderItem} from './ReminderItem';
import {Injectable} from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class SafeDriveReminderItem extends ReminderItem {
  accessibilityPrefix = 'A reminder for your medical certificate for driving which';
  iconMap = {
    'expired': '/assets/reminder/reminder_alert_icon.jpg',
    'expiring': '/assets/reminder/reminder_card_orange.jpg'
  };

  descriptionMap = {
    'expired': 'Expired',
    'expiring': 'Expires'
  };

  constructor(safeDrivingExpireDate,
              private safeDriving: SafeDrivingService) {
    super();
    this.title = 'Your medical certificate to drive expires soon';
    this.actionLink = 'https://www.qld.gov.au/seniors/transport/safe-driving';
    this.analyticsName = 'Safe Drive';
    this.expiryDate = moment(safeDrivingExpireDate).toDate();
    this.status = this.safeDriving.safeDriveStatus(safeDrivingExpireDate);
    this.description = this.descriptionMap[this.status] + ' ' + ReminderItem.formatDate(safeDrivingExpireDate);
    this.accessibility = this.accessibilityPrefix + ' ' + this.descriptionMap[this.status].toLowerCase() + ' ' + ReminderItem.formatDate(this.expiryDate);
    this.icon = this.iconMap[this.status];
    this.dismissId =  'safedrive' + '_' + this.status + '_' + ReminderItem.formatDateForId(this.expiryDate);
  }
}



// WEBPACK FOOTER //
// ./app/reminder/dataObject/SafeDriveReminderItem.ts